import {API_DRIVER} from "../config/axios";
import {ParameterConstants, SocialLoginType} from "../util/constants";
import {IRegisterUserBody} from "../store/auth/Helper";

interface IForgotPassword {
    email: string
}

interface IResendConfirmation {
    email: string
}

interface IResetPassword {
    confirmation_hex: string,
    password: string
}

const getAuthRequestUrl = (endpointUrl: string) => {
    return `/api/auth${endpointUrl}`
}

const AuthService = {
    login: (email: string, password: string) => {
        const formData = new FormData()
        formData.set(ParameterConstants.USERNAME, email)
        formData.set(ParameterConstants.PASSWORD, password)

        return API_DRIVER.post(getAuthRequestUrl(`/login`), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    },
    register: (body: IRegisterUserBody) => {
        return API_DRIVER.post(getAuthRequestUrl(`/register`), body)
    },
    socialLogin: (token: string, type: SocialLoginType) => {
        return API_DRIVER.post(getAuthRequestUrl(`/social-login`), {}, {
            params: {
                user_id: token,
                type
            }
        })
    },
    forgotPassword: (body: IForgotPassword) => {
        return API_DRIVER.post(getAuthRequestUrl(`/forgot-password`), body)
    },
    resetPasswordValid: (confirmationHex: string) => {
        return API_DRIVER.get(getAuthRequestUrl(`/reset-password`), {
            params: {
                confirmation_hex: confirmationHex
            }
        })
    },
    resetPassword: (body: IResetPassword) => {
        return API_DRIVER.patch(getAuthRequestUrl(`/reset-password`), body)
    },
    resendConfirmation: (body: IResendConfirmation) => {
        return API_DRIVER.post(getAuthRequestUrl(`/resend-confirmation`), body)
    },
    verifyConfirmation: (confirmationId: string) => {
        return API_DRIVER.get(getAuthRequestUrl(`/verification/${confirmationId}`))
    }
}

export default AuthService
